// @ts-nocheck
import {
  buildNormalizedAliases,
  buildColumnMap,
  buildRecordFromColumnMap,
  cleanText,
  guessPharmaceuticalCompanyName,
  normalizeHeader,
  shouldSkipRecord,
} from './settlementTemplateHelpers.js';

const DAEWOO_FIELD_ALIASES = {
  accountName: ['처방처'],
  drugName: ['품명'],
  feeRate: ['수수료율'],
  prescriptionAmount: ['실적'],
  settlementAmount: ['수수료'],
};

const REQUIRED_HEADERS = ['처방처', '품명', '실적', '수수료율', '수수료'];

function isDaewooSheet(profile) {
  return (
    normalizeHeader(profile.sheetName) === normalizeHeader('상세내역') &&
    REQUIRED_HEADERS.every((header) =>
      profile.headers.some(
        (candidate) => normalizeHeader(candidate) === normalizeHeader(header),
      ),
    )
  );
}

const daewooPharmTemplate = {
  id: 'daewoo-pharm',
  name: '대우제약 템플릿',
  match(context) {
    return context.headerProfiles.some(isDaewooSheet);
  },
  extract(context) {
    const targetProfile = context.headerProfiles.find(isDaewooSheet);
    if (!targetProfile) {
      return {
        rows: [],
        pharmaceuticalCompanyName: guessPharmaceuticalCompanyName(
          context.file.name,
        ),
        templateName: this.name,
      };
    }

    const sheetName = targetProfile.sheetName;
    const rows = context.sheetRowsMap[sheetName] || [];
    const headerRow = rows[targetProfile.headerRowIndex] || [];
    const columnMap = buildColumnMap(
      headerRow,
      buildNormalizedAliases(DAEWOO_FIELD_ALIASES),
    );
    const detectedPharmaceuticalCompany = '대우제약';
    const extractedRows = [];

    rows.slice(targetProfile.headerRowIndex + 1).forEach((row, rowOffset) => {
      if (!Array.isArray(row) || row.every((cell) => cleanText(cell) === '')) {
        return;
      }

      const record = buildRecordFromColumnMap({
        row,
        columnMap,
        fileName: context.file.name,
        sheetName,
        rowIndex: targetProfile.headerRowIndex + rowOffset + 1,
        templateId: this.id,
        detectedPharmaceuticalCompany,
      });

      if (shouldSkipRecord(record, row)) {
        return;
      }

      extractedRows.push(record);
    });

    return {
      rows: extractedRows,
      pharmaceuticalCompanyName: detectedPharmaceuticalCompany,
      templateName: this.name,
    };
  },
};

export default daewooPharmTemplate;
